import React, { useCallback, useMemo, useState } from 'react';
import EventLabel from '../../../components/EventLabel/EventLabel';
import { displayMoney, roundToNearestHalf, toStringTwoDecimals } from '../../../utils/money.utils';

export default function HotelAllotmentItem({
  price,
  name,
  type,
  dateRangeString,
  nights,
  onAdd,
  totalBeds,
  bookedCount,
  maxBookCount,
  description,
  vatPercent,
  displayEventSettings,
  fullbooked,
  imageUrl,
  supplementPrice,
  supplementVatPercent,
  size,
  currency,
}) {
  const [quantity, setQuantity] = useState(1);

  const handleAdd = () => {
    if (!fullbooked && onAdd) {
      setQuantity(1);
      onAdd(quantity);
    }
  };

  const formattedPrice = useMemo(() => {
    const discountAmount = 0;
    const incVat = displayEventSettings?.['ShowEventIncVat'];

    const newPrice = parseFloat(incVat ? displayMoney(parseFloat(price - discountAmount), vatPercent) : price - discountAmount) * nights;

    const additionalAmount =
      (supplementPrice ? parseFloat(incVat ? displayMoney(parseFloat(supplementPrice), supplementVatPercent) : supplementPrice) * nights : 0) * size;

    return (
      <span>
        {toStringTwoDecimals(newPrice + additionalAmount)}
        <span className="mx-1 text-sm">{currency}</span>
        <span className="mr-1 text-xs text-neutral-500">
          {incVat ? <EventLabel name="IncVat" groupName="CMS.Hotel" /> : <EventLabel name="ExVat" groupName="CMS.Hotel" />}
        </span>
      </span>
    );
  }, [price, vatPercent, displayEventSettings, currency, supplementPrice, supplementVatPercent, nights, size]);

  return (
    <div className="hotel-allotment-item flex flex-col">
      <div className="flex flex-col 2xl:flex-row">
        <div className="min-w-[250px] w-full 2xl:max-w-[250px] h-auto overflow-hidden 2xl:rounded-bl-md 2xl:rounded-tl-md rounded-b-none border-t-md">
          <img src={imageUrl} alt={name} className="object-cover h-full w-full" />
        </div>
        <div className="w-full">
          <div className="price-group  w-full p-2 flex mt-2 md:mt-0 flex-col justify-between ">
            <div className="flex flex-col items-start justify-end">
              <span className="price 2xl:text-right font-bold text-lg">{displayEventSettings?.['ShowEventPrice'] && formattedPrice}</span>
              <span className="nightly-price lg:text-right" style={{ fontWeight: 'normal' }}>
                {nights} <EventLabel name="Nights" groupName="CMS.Hotel" />
              </span>
            </div>
          </div>
          <div className="flex p-2    justify-between lg:w-full flex-col lg:flex-row">
            <div className="flex flex-col w-full">
              <span className="title semi-bold " style={{ marginBottom: 0 }}>
                {name}
              </span>
              <span className="room-type font-normal">{type}</span>
              <span className="font-normal">
                <EventLabel name="Beds" groupName="CMS.Hotel" />: {size}
              </span>
              <span className="font-normal">
                <i className="ri-calendar-line mr-2" />
                {dateRangeString}
              </span>
              <span className="font-normal text-sm  mt-2">{description}</span>
            </div>
          </div>
          <div className="w-full">
            <div className="flex justify-start items-center md:justify-end border-t  border-divider  p-2">
              <div className="flex gap-x-4">
                {maxBookCount > 1 && (
                  <div className="flex gap-x-2 items-center">
                    <button
                      className="rounded-full h-4 w-4 p-2.5 flex justify-center bg-transparent bg-white items-center border border-[rgba(0,0,0,0.2)]"
                      onClick={() => setQuantity(prev => (prev === 0 ? 0 : prev - 1))}
                    >
                      <i className="ri ri-subtract-line" />
                    </button>
                    <p className="text-center text-sm">{quantity || 1}</p>

                    <button
                      disabled={bookedCount === maxBookCount || quantity === maxBookCount - bookedCount}
                      className="rounded-full h-4 w-4 p-2.5 flex justify-center bg-transparent bg-white items-center border border-[rgba(0,0,0,0.2)]"
                      onClick={() => setQuantity(prev => prev + 1)}
                    >
                      <i className="ri ri-add-line" />
                    </button>
                  </div>
                )}
                <button disabled={fullbooked || bookedCount === maxBookCount} onClick={handleAdd} className="cms-button h-fit w-max" style={{ fontSize: 14 }}>
                  {fullbooked ? <EventLabel name="FullBooked" groupName="CMS.Hotel" /> : <EventLabel name="Add" groupName="CMS.Hotel" />}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
